"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("./Icon"));

var LinkExternal = function LinkExternal(_ref) {
  var children = _ref.children,
      className = _ref.className,
      showIcon = _ref.showIcon,
      style = _ref.style,
      title = _ref.title,
      to = _ref.to;

  if (!to || to.length === 0) {
    return null;
  }

  var childIsString = children && typeof children === 'string';
  var displayString = childIsString ? children : title || to;
  return _react.default.createElement("a", {
    className: (0, _classnames.default)('link-external', className),
    href: to,
    rel: "noopener noreferrer",
    style: style,
    target: "_blank"
  }, children || displayString, showIcon && (childIsString || displayString) && _react.default.createElement(_Icon.default, {
    className: "icon relative",
    size: "1em",
    icon: "ios-arrow-dropright",
    style: {
      marginLeft: '0.25em',
      top: '0.15em'
    }
  }));
};

LinkExternal.defaultProps = {
  showIcon: true,
  title: ''
};
var _default = LinkExternal;
exports.default = _default;